import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef, ViewRef } from '@angular/core';
import { StepService } from 'src/app/services/step.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/services/notification.service';
import { ThreeDService } from 'src/app/services/three-d.service';

@Component({
  selector: 'app-step-buttons',
  templateUrl: './step-buttons.component.html',
  styleUrls: ['./step-buttons.component.scss'],
})
export class StepButtonsComponent implements OnInit {
  step: number;
  minStep: number;
  maxStep: number;
  @ViewChild('nextButton') nextButton: ElementRef;
  constructor(
    public stepService: StepService,
    private configurationService: ConfigurationService,
    private notificationService: NotificationService,
    private translateService: TranslateService,
    private cd: ChangeDetectorRef,
    private threeDService: ThreeDService
  ) {}

  ngOnInit() {
    this.stepService.stepChange$.subscribe(stepNumber => (this.step = stepNumber));
    this.configurationService.updateBlockingValues$.subscribe(() => {
      setTimeout(() => {
        if (this.cd && !(this.cd as ViewRef).destroyed) {
          this.cd.detectChanges();
        }
      });
    });

    this.step = this.stepService.getActiveStep();
    this.minStep = this.stepService.getMinStep();
    this.maxStep = this.stepService.getMaxStep();
    this.threeDService.finishedBuilding$.subscribe(() => {
      setTimeout(() => {
        if (this.cd && !(this.cd as ViewRef).destroyed) {
          this.cd.detectChanges();
        }
      }, 3100);
    });

    window.addEventListener('focus', () => {
      setTimeout(() => {
        if (this.cd && !(this.cd as ViewRef).destroyed) {
          this.cd.detectChanges();
        }
      });
    });

    this.threeDService.readyForInput$.subscribe(() => {
      setTimeout(() => {
        if (this.cd && !(this.cd as ViewRef).destroyed) {
          this.cd.detectChanges();
        }
      });
    });
  }

  get blocked(): boolean {
    return this.stepService.forwardBlocked;
  }

  get blockedText(): string {
    return this.translateService.instant(this.stepService.forwardBlockedMessage);
  }

  next() {
    this.step = this.stepService.nextStep();
  }

  previous() {
    this.step = this.stepService.previousStep();
  }

  goToStep(stepNumber: any) {
    this.step = this.stepService.moveToStep(stepNumber);
  }

  showNotificationIfNeeded() {
    if (!this.blocked) {
      this.notificationService.hideBalloonNotification('nextButton');
      return;
    }
    this.notificationService.showBalloonNotification(this.blockedText, this.nextButton.nativeElement);
  }
  hideNotification() {
    this.notificationService.hideBalloonNotification('nextButton');
  }
}
